export enum IndicatorEnum {
  LEADS_VALID_ACCEPTED = "LEADS_VALID_ACCEPTED",
  MONEY_COMMISSION = "MONEY_COMMISSION",
  LEADS_ACCEPTED = "LEADS_ACCEPTED",
  LEADS_SPAMMED = "LEADS_SPAMMED",
  ACTIVE_WEBMASTERS = "ACTIVE_WEBMASTERS"
}
